import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {

  private scripts: any = {};

  constructor() { }

  loadScript(name: string, src: string): Promise<any> {
    if (!this.scripts[name]) {
      // Загрузить скрипт впервые
      this.scripts[name] = { loaded: false, src: src };
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.onload = () => {
          this.scripts[name].loaded = true;
          resolve({ script: name, loaded: true, status: 'Загружено' });
        };
        script.onerror = (error: any) => reject({ script: name, loaded: false, status: 'Не удалось загрузить' });
        document.getElementsByTagName('head')[0].appendChild(script);
      });
    } else if (this.scripts[name].loaded) {
      // Скрипт уже загружен
      return Promise.resolve({ script: name, loaded: true, status: 'Уже загружено' });
    } else {
      // Скрипт все еще загружается
      return Promise.reject({ script: name, loaded: false, status: 'Загрузка в процессе' });
    }
  }
}
